import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "notice" }
const _hoisted_2 = { class: "notice-container" }
const _hoisted_3 = ["innerHTML"]

import { ref } from 'vue';
import { postNoticeInfo } from "@/api";
import { useRoute } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'notice-info',
  setup(__props) {

const route = useRoute();
const noticeId = ref<number>(21668);
const noticeTitle = ref<string>('');
const noticeContent = ref<string>('');

// 获取公告详情
const getNoticeInfo = async  () => {
    const params = {
        id: route.params.id || noticeId.value
    }
    const result =  await postNoticeInfo(params);
    if (result.data?.data) {
        const data = result.data?.data.noticeInfo;
        noticeTitle.value = data.title;
        noticeContent.value = data.content;
    }
}

getNoticeInfo();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(noticeTitle.value), 1),
      _createElementVNode("div", {
        innerHTML: noticeContent.value,
        class: "notice-info"
      }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})